import { render, staticRenderFns } from "./ReduceFileSize.vue?vue&type=template&id=7163bd8c"
import script from "./ReduceFileSize.vue?vue&type=script&lang=js"
export * from "./ReduceFileSize.vue?vue&type=script&lang=js"
import style0 from "./ReduceFileSize.vue?vue&type=style&index=0&id=7163bd8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports